<p>tab-settings-defaultmessage works!</p>
{{Data.mode}}
